/**
 * Cart Upsell (Collection) - shows modal when add to cart on matching collection page or PDP.
 * Modal is only in the DOM on those pages (injected by theme.liquid), so we just show on cart-update from product-form.
 */
(function () {
  if (!window.cartUpsellConfig || !window.cartUpsellConfig.enabled) return;

  const modal = document.getElementById('cart-upsell-modal');
  const closeBtn = document.getElementById('cart-upsell-close-btn');
  const addForm = document.getElementById('cart-upsell-add-form');
  const addButton = document.getElementById('cart-upsell-add-btn');

  if (!modal) return;

  function showModal() {
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function hideModal() {
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  var SESSION_KEY = 'cart_upsell_modal_shown';

  function hasAlreadyShownThisSession() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markAsShownThisSession() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
  }

  /** Return true if popup is allowed by start/end date (America/Chicago). Blank or invalid = no restriction. */
  function isWithinDateRange() {
    var startDateStr = window.cartUpsellConfig && window.cartUpsellConfig.startDate;
    var endDateStr = window.cartUpsellConfig && window.cartUpsellConfig.endDate;
    if (typeof startDateStr === 'string') startDateStr = startDateStr.trim();
    if (typeof endDateStr === 'string') endDateStr = endDateStr.trim();
    try {
      var now = new Date();
      var chicagoDateStr = now.toLocaleDateString('en-CA', { timeZone: 'America/Chicago' });
      if (startDateStr && chicagoDateStr < startDateStr) return false;
      if (endDateStr && chicagoDateStr > endDateStr) return false;
      return true;
    } catch (e) {
      return true;
    }
  }

  function handleCartUpdate(event) {
    if (event.source !== 'product-form') return;
    if (!isWithinDateRange()) return;
    if (hasAlreadyShownThisSession()) return;
    markAsShownThisSession();
    showModal();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', hideModal);
  }

  modal.addEventListener('click', function (e) {
    if (e.target === modal) hideModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      hideModal();
    }
  });

  if (addForm && addButton) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = addForm.querySelector('input[name="id"]');
      variantId = variantId ? variantId.value : (window.cartUpsellConfig && window.cartUpsellConfig.variantId);
      if (!variantId) return;

      addButton.classList.add('loading');
      addButton.setAttribute('aria-disabled', 'true');
      var spinner = addButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      var url = (typeof window.routes !== 'undefined' && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
      var payload = { id: parseInt(variantId, 10) || variantId, quantity: 1 };
      var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      if (typeof fetchConfig === 'function') {
        var config = fetchConfig('json');
        if (config && config.headers) headers = config.headers;
      }

      fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var data;
            try {
              data = text ? JSON.parse(text) : {};
            } catch (e) {
              throw new Error(res.ok ? 'Invalid response' : (res.statusText || 'Request failed'));
            }
            if (!res.ok) {
              var err = new Error(data.message || data.description || res.statusText || 'Could not add to cart');
              err.data = data;
              throw err;
            }
            if (data.status && (data.status === 422 || data.status === 404)) {
              throw new Error(data.message || data.description || 'Could not add to cart');
            }
            return data;
          });
        })
        .then(function () {
          hideModal();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
          }
        })
        .catch(function (err) {
          var message = (err && err.message) ? err.message : 'Unable to add the item. Please try again.';
          if (err && err.data && (err.data.message || err.data.description)) {
            message = err.data.message || err.data.description;
          }
          alert(message);
        })
        .finally(function () {
          addButton.classList.remove('loading');
          addButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  }
})();
